
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ExchangeItemsSelectGrid extends _Ext.GridBase<ECommExchangeItemsRow,any> {
        protected getColumnsKey() { return 'ECommerce.ECommExchangeItemsSelect'; }
        protected getDialogType() { return <any>ECommExchangeItemsDialog; }
        protected getIdProperty() { return ECommExchangeItemsRow.idProperty; }
        protected getLocalTextPrefix() { return ECommExchangeItemsRow.localTextPrefix; } 
        protected getService() { return ECommExchangeItemsService.baseUrl; }

    
        constructor(container: JQuery, options) {
            super(container, options);            
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;

        //protected createSlickGrid(): Slick.Grid {
        //    let grid = super.createSlickGrid();
        //    let x;
        //    ECommExchangeItemsService.CustomList({
        //        ContainsText: ExchangeItemsSelectGrid.ledgerId.toString()
        //    },
        //        response =>
        //            x = response,
        //        { async: false });          
        //    if (ExchangeItemsSelectGrid.ItemType.toString() == "1") {
        //        ECommExchangeItemsService.CustomList({
        //            ItemTypeIds: [101],
        //            LedgerId: ExchangeItemsSelectGrid.ledgerId
        //        },
        //            response =>
        //                x = response,
        //            { async: false });

        //    } else if (ExchangeItemsSelectGrid.ItemType.toString() == "2") {
        //        ECommExchangeItemsService.CustomList({
        //            ItemTypeIds: [104, 105],
        //            LedgerId: ExchangeItemsSelectGrid.ledgerId
        //        },
        //            response =>
        //                x = response,
        //            { async: false });

        //    }
        //    for (let rateitem of x.Entities) {
        //        rateitem[this.getIdProperty()] = rateitem.TransItemId;
        //        //   alert('ID ' + rateitem.CostId);

        //        this.view.addItem(rateitem);
        //    }
        //    //grid.setData(x1, true);
        //    //var c = grid.getData();
            
        //    return grid;
        //}

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): ECommExchangeItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    }
     
}